import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import moment from "moment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import { Customer, CustomerManipulationViewModel } from "../customerManipulation/customerManipulation-viewModel";
import  { CustomerAttributeView } from "./customerAttribute-view"

export class CustomerAttributeViewModel extends ViewModel{
    constructor(parentViewModel: CustomerManipulationViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.attributeValues = ObservableArray.create<CustomerAttributeValueViewModel>();
    }
    GetDefaultView(): View <ViewModel> {
        return new CustomerAttributeView();
    }
    public getTypeId(): string {
        return "VM-2F74B5E2-A24E-469D-B7D5-8AEFAD8A2C8B"
    }
    public set attributeId(v: string) { this._attributeId = v; } public get attributeId(): string { return this._attributeId;} private _attributeId: string;
    public set attributeName(v: string) { this._attributeName = v; } public get attributeName(): string { return this._attributeName;} private _attributeName: string;
    public set newName(v: string) { this._newName = v; } public get newName(): string { return this._newName;} private _newName: string;
    public set attributeValues(v: ObservableArray<CustomerAttributeValueViewModel>) { this._attributeValues = v; } public get attributeValues(): ObservableArray<CustomerAttributeValueViewModel> { return this._attributeValues;} private _attributeValues: ObservableArray<CustomerAttributeValueViewModel>;
    public set edited(v: boolean) { this._edited = v; } public get edited(): boolean { return this._edited;} private _edited: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private _typedParent :CustomerManipulationViewModel;
    
    setAttributeValueToCustomer(dragged: Customer, droppedTo: CustomerAttributeValueViewModel) {
        this._typedParent.setAttributeValueToCustomer(dragged, droppedTo) 
    }
    
    async newAttributeValue() {
        let r = new CustomerAttributeValueViewModel(this);
        r.attributeId = this.attributeId;
        r.attributeName = this.attributeName;
        r.name = '';
        r.edited = true;
        this.attributeValues.push(r);
    }
    
    async editAttribute() {
        this.edited = true;
        this.newName = this.attributeName;
    }
    
    async cancelEditAttribute() {
        this.edited = false;
        this.newName = '';
        if (stringIsNullOrEmpty(this.attributeId))
        {
            this._typedParent.customerAttributes.remove(this);
        }
    }

    async manipulateAttribute() {
        try {
            if (stringIsNullOrEmpty(this.newName))
            {
                await this.messageBoxConfirmWarning('نام نمی تواند خالی باشد','خطا در ورود داده');
                return;
            }
            if (stringIsNullOrEmpty(this.attributeId))
            {
                let confirm = await this.messageBoxWarningYesNo('آیا با ایجاد این ویژگی مطمئنید؟','ایجاد ویژگی');
                if (confirm == 'no'){
                    return;
                }
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/CustomerServices/CreateAttribute',{
                    Name: this.newName
                });
                this.attributeId = result.Id;
                this.attributeName = this.newName;
                this.attributeValues.map(q => {
                    q.attributeId = this.attributeId;
                    q.attributeName = this.attributeName;
                });
                this.edited = false;
                await this.messageBoxConfirmSuccess('ویژگی با موفقیت ایجاد شد.','ایجاد ویژگی');
            } else {
                let confirm = await this.messageBoxWarningYesNo('آیا با ویرایش این ویژگی مطمئنید؟','ویرایش ویژگی');
                if (confirm == 'no'){
                    return;
                }
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/CustomerServices/UpdateAttribute',{
                    AttributeId: this.attributeId,
                    Name: this.newName
                });
                this.attributeName = this.newName;
                this.edited = false;
                await this.messageBoxConfirmSuccess('ویژگی با موفقیت ویرایش شد.','ویرایش ویژگی');
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async deleteAttribute() {
        try {
            let confirm = await this.messageBoxDangerYesNo('آیا با حذف این ویژگی مطمئنید؟','حذف ویژگی');
            if (confirm == 'no'){
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/DeleteAttribute',{
                AttributeId: this.attributeId
            });
            this._typedParent.customerAttributes.remove(this);
            await this.messageBoxConfirmSuccess('ویژگی با موفقیت حذف شد.','حذف ویژگی');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class CustomerAttributeValueViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerAttributeViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId;} private _assignmentId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set newName(v: string) { this._newName = v; } public get newName(): string { return this._newName;} private _newName: string;
    public set attributeId(v: string) { this._attributeId = v; } public get attributeId(): string { return this._attributeId;} private _attributeId: string;
    public set attributeName(v: string) { this._attributeName = v; } public get attributeName(): string { return this._attributeName;} private _attributeName: string;
    public set attributeValueId(v: string) { this._attributeValueId = v; } public get attributeValueId(): string { return this._attributeValueId;} private _attributeValueId: string;
    public set appliedFrom(v: moment.Moment) { this._appliedFrom = v; } public get appliedFrom(): moment.Moment { return this._appliedFrom;} private _appliedFrom: moment.Moment   ;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    public set edited(v: boolean) { this._edited = v; } public get edited(): boolean { return this._edited;} private _edited: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private _typedParent :CustomerAttributeViewModel;

    override handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker){
            if(message.dragged instanceof Customer && message.droppedTo instanceof CustomerAttributeValueViewModel){
                return message.createAllowanceResponse(`اضافه کردن مقدار ویژگی ${message.droppedTo.attributeName} به مشتری ${message.dragged.name}`);
            }else{
                return message.createRejectResponse();
            }
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof Customer && message.droppedTo instanceof CustomerAttributeValueViewModel){
            this._typedParent.setAttributeValueToCustomer(message.dragged,message.droppedTo);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }

    async editAttributeValue() {
        this.edited = true;
        this.newName = this.name;
    }
    
    async cancelEditAttributeValue() {
        this.edited = false;
        this.newName = '';
        if (stringIsNullOrEmpty(this.attributeValueId))
        {
            this._typedParent.attributeValues.remove(this);
        }
    }

    async manipulateAttributeValue() {
        try {
            if (stringIsNullOrEmpty(this.newName))
            {
                await this.messageBoxConfirmWarning('نام نمی تواند خالی باشد','خطا در ورود داده');
                return;
            }
            if (stringIsNullOrEmpty(this.attributeId))
            {
                await this.messageBoxConfirmWarning('ویژگی وجود ندارد','خطا در ورود داده');
                return;
            }
            if (stringIsNullOrEmpty(this.attributeValueId))
            {
                let confirm = await this.messageBoxWarningYesNo('آیا با ایجاد این مقدار ویژگی مطمئنید؟','ایجاد مقدار');
                if (confirm == 'no'){
                    return;
                }
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/CustomerServices/CreateAttributeValue',{
                    AttributeId: this.attributeId,
                    Name: this.newName
                });
                this.attributeValueId = result.Id;
                this.name = this.newName;
                this.edited = false;
                await this.messageBoxConfirmSuccess('مقدار ویژگی با موفقیت ایجاد شد.','ایجاد مقدار');
            } else {
                let confirm = await this.messageBoxWarningYesNo('آیا با ویرایش این مقدار ویژگی مطمئنید؟','ویرایش مقدار');
                if (confirm == 'no'){
                    return;
                }
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/CustomerServices/UpdateAttributeValue',{
                    Id: this.attributeValueId,
                    Name: this.newName
                });
                this.name = this.newName;
                this.edited = false;
                await this.messageBoxConfirmSuccess('مقدار ویژگی با موفقیت ویرایش شد.','ویرایش مقدار');
            }
         } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async deleteAttributeValue() {
        try {
            let confirm = await this.messageBoxDangerYesNo('آیا با حذف این مقدار ویژگی مطمئنید؟','حذف مقدار');
            if (confirm == 'no'){
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/DeleteAttributeValue',{
                Id: this.attributeValueId
            });
            this._typedParent.attributeValues.remove(this);
            await this.messageBoxConfirmSuccess('مقدار ویژگی با موفقیت حذف شد.','حذف مقدار');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}
